import { Link } from "react-router-dom";
import PageLayout from "@/components/feature/PageLayout";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import FeaturedMovies from "@/pages/home/components/FeaturedMovies";
import LatestShorts from "@/pages/home/components/LatestShorts";
import MoodCollections from "@/pages/home/components/MoodCollections";
import RankingList from "@/pages/home/components/RankingList";
import { usePageMeta } from "@/hooks/usePageMeta";
import { siteHighlights } from "@/mocks/site";

export default function Home() {
  usePageMeta(
    "午夜视频 - 高清午夜电影及精彩短视频平台",
    "午夜视频为您提供丰富的午夜电影和精选视频内容，包括最新上映影片和热门短视频，满足您深夜观影和娱乐的多样需求。",
    "午夜视频,午夜电影,午夜影视,深夜电影,午夜娱乐,在线观看午夜影片,午夜短视频",
  );

  return (
    <PageLayout>
      <HeroCarousel />

      <section className="w-full px-4 md:px-8">
        <div className="mt-4 grid grid-cols-2 gap-3 rounded-lg border border-background-800 bg-background-900/90 p-4 backdrop-blur-sm md:-mt-10 md:grid-cols-4 md:gap-0 md:p-0">
          {siteHighlights.map((item, index) => (
            <div
              key={item.label}
              className={`flex flex-col gap-1.5 rounded-md px-3 py-3 md:px-6 md:py-5 ${
                index !== siteHighlights.length - 1 ? "md:border-r md:border-background-800" : ""
              }`}
            >
              <span className="flex items-center gap-1.5 text-xs text-foreground-500">
                <i className={`${item.icon} text-sm text-accent-500`} />
                {item.label}
              </span>
              <span className="font-label text-2xl tracking-wide text-foreground-50 md:text-3xl">
                {item.value}
              </span>
            </div>
          ))}
        </div>
      </section>

      <FeaturedMovies />
      <LatestShorts />
      <MoodCollections />
      <RankingList />

      <section className="w-full px-4 pt-14 md:px-8 md:pt-20">
        <div className="relative overflow-hidden rounded-lg border border-background-800 bg-primary-900 px-5 py-10 md:px-10 md:py-12">
          <div className="absolute -right-16 -top-16 h-56 w-56 rounded-full bg-accent-500/10 blur-2xl" />
          <div className="relative flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
            <div className="max-w-2xl">
              <p className="flex items-center gap-2 text-xs text-accent-400">
                <i className="ri-moon-foggy-line text-base" />
                还差一部片，今晚就完整了
              </p>
              <h2 className="mt-3 font-heading text-xl font-bold leading-snug text-foreground-50 md:text-2xl">
                不知道看什么？让分类和关键词帮你决定
              </h2>
              <p className="mt-2 text-sm leading-6 text-foreground-300">
                按类型、地区、年份逐层筛选，或用一句话描述你想看的氛围。所有条目都附有完整影片资料与相关推荐。
              </p>
            </div>
            <div className="flex flex-col gap-3 sm:flex-row">
              <Link
                to="/movies"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-3 text-sm font-medium text-background-950 transition-colors hover:bg-accent-400"
              >
                进入电影分类
                <i className="ri-arrow-right-line text-base" />
              </Link>
              <Link
                to="/search"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-secondary-500/40 px-5 py-3 text-sm text-foreground-100 transition-colors hover:border-accent-500/70 hover:text-accent-400"
              >
                <i className="ri-search-line text-base" />
                搜索影片
              </Link>
            </div>
          </div>
        </div>
      </section>
    </PageLayout>
  );
}